import { c as _c } from "react/compiler-runtime";
import { useQuestionsStore } from "../../../../store/questionsStore";
export const QuesSheetRadioButtons = t0 => {
  const $ = _c(18);
  const {
    currentQuestionData,
    setAnswers,
    answers,
    handleNext,
    handleQuestionSheetSubmit
  } = t0;
  const options = currentQuestionData.options;
  const {
    storeAnswers
  } = useQuestionsStore();
  const isLastScreen = currentQuestionData?.navigation?.next === "end";
  let t1;
  if ($[0] !== answers || $[1] !== currentQuestionData || $[2] !== handleNext || $[3] !== handleQuestionSheetSubmit || $[4] !== isLastScreen || $[5] !== options || $[6] !== setAnswers) {
    t1 = value => {
      const selectedOption = options.find(opt => opt.value === value);
      setAnswers({
        ...answers,
        [currentQuestionData.id]: {
          ...currentQuestionData,
          value,
          answer: selectedOption.label
        }
      });
      if (isLastScreen) {
        handleQuestionSheetSubmit();
        return;
      }
      if (handleNext && !isLastScreen) {
        setTimeout(() => {
          handleNext({
            answerValue: value
          });
        }, 300);
      }
    };
    $[0] = answers;
    $[1] = currentQuestionData;
    $[2] = handleNext;
    $[3] = handleQuestionSheetSubmit;
    $[4] = isLastScreen;
    $[5] = options;
    $[6] = setAnswers;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleAnswerChange = t1;
  const currentAnswer = answers[currentQuestionData.id];
  const selectedValue = currentAnswer?.value || storeAnswers[currentQuestionData.id]?.value;
  let t2;
  if ($[8] !== handleAnswerChange || $[9] !== options || $[10] !== selectedValue) {
    let t3;
    if ($[12] !== handleAnswerChange || $[13] !== options.length || $[14] !== selectedValue) {
      t3 = (option, index) => <div onClick={() => handleAnswerChange(option.value)} key={option.value} className={`flex justify-between items-center border border-[-1px solid --colorOutlineOutline] cursor-pointer ${index === options.length - 1 ? "" : "border-b-0"}  p-4 gap-3 h-[72px] `}><label className="flex items-center cursor-pointer"><input type="radio" checked={selectedValue === option.value} onChange={_temp} className="w-5 h-5 mr-3 cursor-pointer" /><span className="m3-body-large text-[--textPrimaryPrimary]">{option.label}</span></label></div>;
      $[12] = handleAnswerChange;
      $[13] = options.length;
      $[14] = selectedValue;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t2 = options.map(t3);
    $[8] = handleAnswerChange;
    $[9] = options;
    $[10] = selectedValue;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[16] !== t2) {
    t3 = <div>{t2}</div>;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
function _temp() {}